import React, { ReactNode, useContext, useEffect, useMemo, useState } from 'react';
import { getRetailSubscription } from '@services/opa/Opa.service';
import { OpaSubscription } from '@models/Opa';
import { SubscriptionsConfig, SubscriptionsContext } from './Context';
import saveErrorLog, { ErrorTagEnum } from '@utils/LogUtil';

interface SubscriptionsProviderProps {
  children: ReactNode;
}

const SubscriptionsProvider: React.FC<SubscriptionsProviderProps> = ({ children }) => {
  const [subscriptions, setSubscriptions] = useState<OpaSubscription>({} as OpaSubscription);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await getRetailSubscription();
        if (mounted) setSubscriptions(data);
      } catch (err) {
        saveErrorLog(err, 'SubscriptionsProvider - Get subscription error.', {
          category: ErrorTagEnum.ApiError,
          requestPayload: '',
        });
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const value = useMemo<SubscriptionsConfig>(
    () => ({ subscriptions, loadingSubscriptions: loading }),
    [subscriptions, loading],
  );

  return <SubscriptionsContext.Provider value={value}>{children}</SubscriptionsContext.Provider>;
};

const useSubscriptions = (): SubscriptionsConfig => useContext(SubscriptionsContext);

export { SubscriptionsProvider, useSubscriptions };
